import { fromLonLat } from 'ol/proj';
import { Style, Fill, Stroke, RegularShape, Icon } from 'ol/style';
import Feature from 'ol/Feature';
import { Point, Polygon } from 'ol/geom';
import { alertObjType } from 'features/alerts/types';
import { latlngType } from '../types';
import pin from '../../../assets/pin.png';

export const drawAreaFromAlert = (alert:alertObjType) => {
  const leftTopCoords = fromLonLat([alert.longitude_nw, alert.latitude_nw] as [number, number])
  const rightBottomCoords = fromLonLat([alert.longitude_se, alert.latitude_se] as [number, number])
  const rectangleCoords = [
    rightBottomCoords,
    [leftTopCoords[0], rightBottomCoords[1]],
    leftTopCoords,
    [rightBottomCoords[0], leftTopCoords[1]],
    rightBottomCoords, 
  ]

  const rectangleGeometry = new Polygon([rectangleCoords]);

  const rectangleFeature = new Feature({
    geometry: rectangleGeometry,
    title: alert.name
  });

  const fillArea = new Fill({ color: 'rgba(255, 0,0, 0.01)' });
  const stroke = new Stroke({ color: 'red', width: 2 }); // 長方形の境界線の色と太さ

  rectangleFeature.setStyle(
    new Style({
      fill: fillArea,
      stroke: stroke,
    })
  );
  return rectangleFeature
}

export const drawPointFromAlert = (alert:alertObjType) => {
  const point =  new Feature({
    geometry: new Point(fromLonLat([alert.longitude, alert.latitude])),
    title: alert.name
  });

  point.setStyle(
    new Style({
      image: new Icon({
        src: pin,
        scale: 1,
      }),
    }),
  );
  
  return point
}

export const drawPinFromLonlat = (latlng:latlngType):Feature<Point> => {
  if (!latlng){
    return new Feature({
      geometry: new Point([0, 0]), // もしくは適当な初期値
    });
  }
  const pin = new Feature({
    geometry: new Point(fromLonLat([latlng[1], latlng[0]])),
  });
  const fillPoint = new Fill({ color: 'red' });

  pin.setStyle(
    new Style({
      image: new RegularShape({
        fill: fillPoint,
        points: 10,
        radius: 7,
        angle: 0,
      }),
    }),
  );
  
  return pin
 
}